module.exports = __webpack_public_path__ + "img/notask.24f33d86.png";